import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { navigationItems, handleAnchorClick, isCurrentPage } from '../utils/navigation';

export const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav role="navigation" aria-label="Navigation principale" className="flex-1 flex justify-center">
      <ul className="flex gap-8 list-none m-0 p-0" role="menubar">
        {navigationItems.map((item) => {
          const isCurrent = isCurrentPage(location.pathname, item.href);
          
          return (
            <li key={item.key} role="none">
              <a
                href={item.href}
                role="menuitem"
                className={`nav-link ${isCurrent ? 'text-primary-600' : ''}`}
                tabIndex={0}
                aria-current={isCurrent ? 'page' : undefined}
                onClick={(e) => handleAnchorClick(e, item.href, navigate, location.pathname)}
              >
                {item.label}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};